// Reglas de los Elements Tierra en la renovación y la mejora de la suscripción (solo ahí se pueden usar).
// El precio lo da el backend en GET subscriptionOptions (elementEarthPrice, variable ELEMENTS_EARTH_PRICE)
// y es el mismo con el que se cobra; el front no lo fija.

/**
 * Precio de un Element Tierra a partir de la respuesta del backend. 0 si no viene o no es válido:
 * con precio 0 los Elements Tierra quedan deshabilitados (backend sin desplegar o error al consultar).
 */
export const resolveElementEarthPrice = (value: unknown): number =>
{
    return typeof value === "number" && isFinite(value) && value > 0 ? value : 0;
};

/**
 * Elements enteros necesarios para cubrir un importe, redondeando hacia arriba. Se quita antes el ruido
 * de coma flotante (6 / 0.006 = 1000.0000000000001) para no pedir un Element de más.
 */
export const elementsToCover = (euros: number, unitPrice: number): number =>
{
    if(!(unitPrice > 0) || !(euros > 0))
    {
        return 0;
    }

    return Math.ceil(Number((euros / unitPrice).toFixed(6)));
};

/**
 * Elements enteros que caben en un importe, redondeando hacia abajo y sin ruido de coma flotante.
 */
export const elementsWithinBudget = (euros: number, unitPrice: number): number =>
{
    if(!(unitPrice > 0) || !(euros > 0))
    {
        return 0;
    }

    return Math.floor(Number((euros / unitPrice).toFixed(6)));
};
